import React from 'react';
import { Trophy, BookOpen, Activity, Users, MapPin } from 'lucide-react';
export function SystemIntro() {
  return <section className="py-20 bg-brand-blue text-white" data-id="element-301">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-302">
        <div className="inline-flex items-center justify-center gap-2 bg-white/10 px-6 py-2 rounded-full mb-8" data-id="element-303">
          <Trophy className="w-5 h-5 text-brand-gold" data-id="element-304" />
          <span className="font-bold tracking-wide" data-id="element-305">
            El Sistema N°1 para Profesores de Natación Argentinos
          </span>
        </div>

        <h2 className="text-4xl md:text-5xl font-heading font-bold mb-6" data-id="element-306">
          NATACIÓN 360 — Colección Completa
        </h2>
        <p className="text-xl md:text-2xl text-blue-100 mb-12 font-medium" data-id="element-307">
          12 Tomos + 6 Bonus + 2 Élite <br className="md:hidden" data-id="element-308" />
          <span className="text-brand-gold" data-id="element-309">
            Todo resuelto. Todos los niveles.
          </span>
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-310">
          <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm border border-white/20" data-id="element-311">
            <BookOpen className="w-8 h-8 mx-auto mb-3 text-brand-light" data-id="element-312" />
            <div className="font-bold text-2xl" data-id="element-313">+280</div>
            <div className="text-sm text-blue-200" data-id="element-314">páginas</div>
          </div>
          <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm border border-white/20" data-id="element-315">
            <Activity className="w-8 h-8 mx-auto mb-3 text-brand-light" data-id="element-316" />
            <div className="font-bold text-2xl" data-id="element-317">+84</div>
            <div className="text-sm text-blue-200" data-id="element-318">ejercicios graficados</div>
          </div>
          <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm border border-white/20" data-id="element-319">
            <Users className="w-8 h-8 mx-auto mb-3 text-brand-light" data-id="element-320" />
            <div className="font-bold text-2xl" data-id="element-321">Todos</div>
            <div className="text-sm text-blue-200" data-id="element-322">los niveles</div>
          </div>
          <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm border border-white/20" data-id="element-323">
            <MapPin className="w-8 h-8 mx-auto mb-3 text-brand-light" data-id="element-324" />
            <div className="font-bold text-2xl" data-id="element-325">100%</div>
            <div className="text-sm text-blue-200" data-id="element-326">Argentina</div>
          </div>
        </div>
      </div>
    </section>;
}